import { Button, CircularProgress, Grid } from "@material-ui/core";
import { Print } from "@material-ui/icons";
import moment from "moment";
import { useContext, useState } from "react";
import { QueryParamsContext } from "../../../../../context/QueryParamsContext";
import { b64toBlob } from "../../../../../utils/file64toBlob";
import { notify } from "../../../../../utils/notify";
import { periods } from "../../../constants";

import { printCustomerRankingPDF } from "../../../../../repositories/qerpapi/erp/relatorio/RankingClienteRepository";
import { dateFilters, rankCriterias } from "../../RankingClienteConstants";
import { useRankingClienteService } from "../../context/RankingClienteContext";
import ExportButton from "../ExportButton";

export const ReportActions = () => {
  const [printLoading, setPrintLoading] = useState(false);
  const {
    cachedPeriod: period,
    filters,
    cachedSituations,
    quickSituations,
    cachedCompanies,
    cachedMovementData,
    checkedOrigins,
  } = useRankingClienteService();
  const { queryParams } = useContext(QueryParamsContext);

  const handlePrintPDF = async () => {
    const filtersDescriptions = {
      period: {
        label: "Período",
        formatedValue: (searchPeriod) => {
          const objEntries = Object.entries(periods);
          const [key] = objEntries.find(([_, value]) => value === searchPeriod);
          return key;
        },
      },
      startDate: {
        label: "Data inicial",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },
      endDate: {
        label: "Data final",
        formatedValue: (date) =>
          moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      },

      multicompany: {
        label: "Empresa",
        formatedValue: (company) => {
          const objEntries = Object.entries(cachedCompanies);
          const companies = objEntries.find(([_, value]) => value === company);
          return companies[0] ?? queryParams?.nomeempresa;
        },
      },

      dateFilter: {
        label: "Data de",
        formatedValue: (dateType) => {
          const objEntries = Object.entries(dateFilters);
          const [key] = objEntries.find(([_, value]) => value === dateType);
          return key;
        },
      },
      status: {
        label: "Situações",
        formatedValue: (_) => {
          const status = cachedSituations
            .filter((situation) => filters.status?.includes(situation.id))
            .map((situation) => situation.desc);
          return status.join(", ");
        },
      },
      quickStatus: {
        label: "Situações Rápidas",
        formatedValue: (_) => {
          const status = quickSituations
            .filter((situation) => filters.quickStatus?.includes(situation.id))
            .map((situation) => situation.desc);
          return status.join(", ");
        },
      },
      origin: {
        label: "Origens",
        formatedValue: (_) => {
          const status = checkedOrigins
            .filter((origin) => filters.origin?.includes(origin.id))
            .map((origin) => origin.desc);
          return status.join(", ");
        },
      },
      rankCriteria: {
        label: "Critério de Ranqueamento",
        formatedValue: (rankCriteria) => {
          const objEntries = Object.entries(rankCriterias);
          const [key] = objEntries.find(([_, value]) => value === rankCriteria);
          return key;
        },
      },
    };

    setPrintLoading(true);

    const pdfBody = {
      title: "Relatório de Ranking de Clientes",
      type: "DETALHADO",
      group: "Empresa",
      companyName: queryParams?.nomeempresa,
      companyFantasy: queryParams?.apelido,
      headerLogo: queryParams?.imagebase64,
      footerLogo: queryParams?.imagebase64,
      login: queryParams?.usuario_nome,
      filter: Object.entries(filters)
        .filter(([key, _]) => !!filtersDescriptions[key])
        .map(([key, value]) => ({
          field: filtersDescriptions[key].label,
          value: filtersDescriptions[key].formatedValue(value),
        })),
      movement: cachedMovementData,
      searchPeriod: period,
      total: {
        originalAmount: 0,
        increase: 0,
        discount: 0,
        netValue: 0,
        finishedAmount: 0,
      },
    };
    const res = await printCustomerRankingPDF(pdfBody);
    setPrintLoading(false);
    if (res?.status !== 200) {
      return notify("Falha ao imprimir relatório", true, "error");
    }

    const blob = b64toBlob(res?.data?.fileBase64, "application/pdf");
    const url = URL.createObjectURL(blob);
    window.open(url);
  };

  return (
    <Grid item container direction="row" spacing={1}>
      <Grid item xs />
      <Grid item>
        <ExportButton
          data={cachedMovementData}
          filename={`ranking-clientes-${Date.now()}`}
        />{" "}
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="contained"
          startIcon={printLoading ? <CircularProgress size={16} /> : <Print />}
          color="primary"
          disabled={printLoading || !cachedMovementData.length}
          onClick={handlePrintPDF}
        >
          {printLoading ? "Gerando relatório..." : "Imprimir"}
        </Button>
      </Grid>
    </Grid>
  );
};
